module.exports = __webpack_public_path__ + "fonts/IRANYekanRegular.7013263.woff2";